<div>
  <div class="d-flex justify-content-between">
    <span class="q-c-main managerTitle">Sélectionnés ({{service.EffectifModel.DataListSelect.length}})</span>
    <span class=" q-c-danger q-pointer" (click)="openModalSpe(ModalRetirerTous,'lg')">Retirer tous</span>
  </div>
  <div class="q-render-container my-3 " [ngClass]="{'q-render-vide':service.EffectifModel.DataListSelect.length == 0}">
    <effectifs-render class="h-100"
                      [Mode]="CRUD.DELETE"
                      [List]="service.EffectifModel.DataListSelect"
                      [EffectifSelected]="EffectifSelected">
    </effectifs-render>
  </div>
  <div class="d-flex justify-content-between my-3">
    <button class="q-btn q-main" (click)="open(ModalBO, '0')" *ngIf="service.Options.RenderType != RenderType.PMSTAGE">Créer</button>
    <button class="q-btn q-main" (click)="ChangeShowCustomerDropdown()" *ngIf="service.Options.RenderType == RenderType.PMSTAGE">Créer</button>
    <div *ngIf="ShowCustomerDropdown" (click)="stopPropagation($event)" class="customerDropdown p-2 d-flex flex-column">
      <button (click)="open(ModalBO, '0')" class="q-btn mr-0 mb-1">Client</button>
      <button class="q-btn mr-0" (click)="openModalClientInd(ModalBOInd)">Client Individuel</button>
    </div>
    <!--<div class="checkbox checbox-switch switch-primary">
      <label>
        <input type="checkbox" />
        <span></span>Cursus
      </label>
    </div>-->
  </div>
  <div *ngIf="service.Options.RenderType == RenderType.PMSTAGE">
    <p class="d-flex justify-content-center">Recherchez un client à ajouter</p>
    <q-autosearch class="w-100" [Mode]="'CLIENT'" [CustomClass]="'w-100 q-main-focus'" [InputWithDelete]="false" (SetInput)="AddEffectifToSelect($event)"></q-autosearch>
    <button class="q-btn w-100 mt-2" (click)="openModalSpe(ModalBO_find)">Recherche avancée </button>
  </div>

  <div *ngIf="service.Options.RenderType != RenderType.PMSTAGE">
    <p class="d-flex justify-content-center">Recherchez un contact à ajouter</p>
    <q-autosearch class="w-100" [List]="service.EffectifModel.DataListAll" [Mode]="'Contacts'" [CustomClass]="'w-100 q-main-focus'" [InputWithDelete]="false" (SetInput)="AddEffectifToSelect($event)"></q-autosearch>
    <div class="d-flex justify-content-between">
      <span class="q-c-main managerTitle">Disponibles ({{service.EffectifModel.DataListAll.length}})</span>
      <span class="q-c-success q-pointer" (click)="AddAll()">Ajouter tous</span>
    </div>
    <div *ngIf="service.isLoading" class="justify-content-center row w-100 my-5"><i class="fas fa-spin fa-spinner fa-pulse q-c-main fa-5x"></i></div>
    <div class="q-render-container my-3" *ngIf="service.EffectifModel.DataListAll" [ngClass]="{'q-render-vide':service.EffectifModel.DataListAll.length == 0,'d-none': service.isLoading}">
      <effectifs-render class="h-100"
                        [Mode]="CRUD.CREATE"
                        [List]="service.EffectifModel.DataListAll">
      </effectifs-render>
    </div>
  </div>
</div>



<!-- Modals BO -->
<ng-template #ModalBO class="modal-dialog-centered" let-modal>
  <div class="modal_content">
    <div class="modal-header">
      <div *ngIf="service.Model.NameBO == 'BO_CONTACT'" class="col-11 q-text-xl q-c-main">Création d'un apprenant</div>
      <div *ngIf="service.Model.NameBO == 'BO_CSOC'" class="col-11 q-text-xl q-c-main">Création d'un client</div>
      <div *ngIf="service.Model.NameBO == 'BO_FORMATEUR'" class="col-11 q-text-xl q-c-main">Création d'un formateur</div>
      <div class="col-auto d-flex justify-content-end">
        <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <div *ngIf="service.Model.NameBO == 'BO_CONTACT'" class="p-4 d-flex">
      <select [ngModel]="service.EffectifModel.AllData.IdOrigin"
              class="q-main-select"
              (ngModelChange)="GetContactForClient($event)">
        <option value="" *ngIf="service.EffectifModel.DataListFilter?.length > 1">Selectionnez un client à associer</option>
        <option *ngFor="let Filter of service.EffectifModel.DataListFilter" value="{{Filter.Id}}">{{Filter.Text}}</option>
      </select>

      <div class="q-check ml-2">
        <input type="checkbox" [(ngModel)]="service.EffectifModel.IsContactPrincipal" id="checkPrincipal" />
        <label class="d-flex mb-0 align-items-center" for="checkPrincipal">
          <span></span>
          <ng-container>Créer en contact principal</ng-container>
        </label>
      </div>
    </div>

    <q-bodisplay *ngIf="this.service.EffectifModel.AllData.IdOrigin != '' || service.Model.NameBO != 'BO_CONTACT'"
                 class="w-100 h-100 mb-5 mt-3"
                 [item]="service.Model"
                 (sendEvent)="InsertLienEffectif($event, modal)">
    </q-bodisplay>

  </div>
</ng-template>

<!-- Modal BO pour les clients individuels ( c'est un bo contact mais on va se servir de ces infos pour ensuite créer un client ) -->
<ng-template #ModalBOInd class="modal-dialog-centered" let-modal>
  <div class="modal_content">
    <div class="modal-header">
      <div class="col-11 q-text-xl q-c-main">Création d'un Client Individuel</div>
      <div class="col-auto d-flex justify-content-end">
        <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <q-bodisplay class="w-100 h-100 mb-5 mt-3"
                 [item]="service.Model"
                 (sendEvent)="CreateClientInd($event, modal)">
    </q-bodisplay>

  </div>
</ng-template>

<!-- Modals BO-find pour les clients -->

<ng-template #ModalBO_find class="modal-dialog-centered" let-modal>
  <div class="modal_content">
    <div class="modal-header d-flex justify-content-end">
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <q-search [idBo]="service.Model.IdentBO" [codeRelation]="service.Model.IdRelation" [idPere]="service.Model.IdDonneePere" [modelForLink]="modelForQSearch" (success)="RefreshComponentAfterAdd($event)"></q-search>
  </div>
</ng-template>

<!-- Modal de confirmation de suppression -->
<ng-template #ModalRetirerTous let-modal>
  <div class="modal_content">
    <div class="justify-content-end mr-3 mt-3">
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-header justify-content-center">
      <div *ngIf="service.Options.RenderType == RenderType.PMSTAGE" class="q-text-xl q-c-main">
        Retirer toutes les personnes morales
      </div>
      <div *ngIf="service.Options.RenderType != RenderType.PMSTAGE" class="q-text-xl q-c-main">
        Retirer toutes les personnes physiques
      </div>
    </div>
    <div class="modal-body justify-content-center">
      <div *ngIf="service.Options.RenderType == RenderType.PMSTAGE">
        <p>Vous êtes sur le point de retirer toutes les personnes morales, confirmez vous la suppression?</p>
      </div>
      <div *ngIf="service.Options.RenderType != RenderType.PMSTAGE">
        <p>Vous êtes sur le point de retirer les personnes physiques, confirmez vous la suppression?</p>
      </div>      
    </div>

    <div class="modal-footer">
      <div class="justify-content-center">
        <button (click)="modal.dismiss()" class="q-btn q-primary"><i class="fas fa-times mr-2"></i>Annuler</button>
        <button (click)="UnselectAll(); modal.dismiss();" class="q-btn q-danger"><i class="fas fa-trash mr-2"></i>Supprimer</button>
      </div>
    </div>
  </div>
</ng-template>

